import {useState} from 'react'
import {getDistrict} from '../services'
import {fetchData} from '../util/functionService'
import {mapDataSelect} from '../../../util/functions'
import {LocationModel} from '../model'
const useDistrict = () => {
  const [district, setDistrict] = useState<LocationModel[]>([])
  const [district2, setDistrict2] = useState<LocationModel[]>([])

  const getDataDistrict = async (id: string = '') => {
    const response = (await fetchData(getDistrict, id)) || []
    return response
  }

  const getDistrict1 = async (id: string = '') => {
    const data = await getDataDistrict(id)
    const mappedData = mapDataSelect(data)
    setDistrict(mappedData)
  }
  const getDistrict2 = async (id: string = '') => {
    const data = await getDataDistrict(id)
    const mappedData = mapDataSelect(data)
    setDistrict2(mappedData)
  }
  const handleClearDistrict = async () => {
    setDistrict([])
  }
  const handleClearDistrict2 = async () => {
    setDistrict2([])
  }
  const handleClear = async () => {
    setDistrict2([])
    setDistrict([])
  }
  return {
    district,
    getDistrict1,
    district2,
    getDistrict2,
    handleClearDistrict,
    handleClearDistrict2,
    handleClear,
  }
}

export default useDistrict
